import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Trying the new ResizeObserver and IntersectionObserver APIs",
  "description": "",
  "published": "2019-04-03T00:00:00.000Z",
  "redirect_from": ["/blog/trying-the-new-resizeobserver-and-intersectionobserver-apis/swizec/9005"],
  "categories": "Front End, Livecoding, Technical",
  "hero": "./img/techletter.app-screenshot-1554309442351.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You might remember the `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/useDimensions"
      }}>{`useDimensions`}</a>{` React Hook I opensourced a few weeks ago. 246 stars, 2 issues, and 1 merged PR make it the most useful library I ever released 💪 Some 10 days ago I made it update measurements live. Needed to make this working for a client project 👇 `}<a parentName="p" {...{
        "href": "/e3d570cbbc60faf9bb7b20f3cadb23b8/8kYM6gu.gif"
      }}><img parentName="a" {...{
          "src": "/e3d570cbbc60faf9bb7b20f3cadb23b8/Scrollable-overlay-highlightb344je.gif",
          "alt": "Scrollable overlay highlight"
        }}></img><br parentName="a"></br>
        {`Scrollable overlay highlight`}</a>{` It's not perfect, but that highlight is a hole punched through a darkened canvas. It uses `}<inlineCode parentName="p">{`useDimensions`}</inlineCode>{` for positioning and needs to update when you scroll. Works good enough. Built with hooks, live updating looks like this: `}<a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=useLayoutEffect(()%20%3D%3E%20%7B%0A%20%20%20%20if%20(node)%20%7B%0A%20%20%20%20%20%20%20%20const%20measure%20%3D%20()%20%3D%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20window.requestAnimationFrame(()%20%3D%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20setDimensions(getDimensionObject(node))%0A%20%20%20%20%20%20%20%20%20%20%20%20)%3B%0A%20%20%20%20%20%20%20%20measure()%3B%0A%0A%20%20%20%20%20%20%20%20window.addEventListener(%22resize%22%2C%20measure)%3B%0A%20%20%20%20%20%20%20%20window.addEventListener(%22scroll%22%2C%20measure)%3B%0A%0A%20%20%20%20%20%20%20%20return%20()%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20window.removeEventListener(%22resize%22%2C%20measure)%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20window.removeEventListener(%22scroll%22%2C%20measure)%3B%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%0A%7D%2C%20%5Bnode%5D)%3B%0A"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "566px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "86.99551569506727%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'348\\'%20viewBox=\\'0%200%20400%20348\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2036a6962%206962%200%20001%20278h352a6962%206962%200%20001-278c-1-3-353-3-354%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/9a3606d6f08c0b04ef3628d90bb66553/ca0a1/techletter.app-screenshot-1554309442351.webp 223w", "/static/9a3606d6f08c0b04ef3628d90bb66553/75680/techletter.app-screenshot-1554309442351.webp 445w", "/static/9a3606d6f08c0b04ef3628d90bb66553/3161c/techletter.app-screenshot-1554309442351.webp 566w"],
              "sizes": "(max-width: 566px) 100vw, 566px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/9a3606d6f08c0b04ef3628d90bb66553/e92b6/techletter.app-screenshot-1554309442351.png 223w", "/static/9a3606d6f08c0b04ef3628d90bb66553/e66bf/techletter.app-screenshot-1554309442351.png 445w", "/static/9a3606d6f08c0b04ef3628d90bb66553/6fe44/techletter.app-screenshot-1554309442351.png 566w"],
              "sizes": "(max-width: 566px) 100vw, 566px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/9a3606d6f08c0b04ef3628d90bb66553/6fe44/techletter.app-screenshot-1554309442351.png",
              "alt": "techletter app screenshot 1554309442351",
              "title": "techletter app screenshot 1554309442351",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`We use a `}<inlineCode parentName="p">{`useLayoutEffect`}</inlineCode>{` to run our code synchronously on DOM updates. Inside, we check that the `}<inlineCode parentName="p">{`node`}</inlineCode>{` exists, then create a debounced `}<inlineCode parentName="p">{`measure()`}</inlineCode>{` function. Measure runs on `}<inlineCode parentName="p">{`requestAnimationFrame`}</inlineCode>{` so we don't kill the browser even if the code falls into an infinite loop. You might get small subpixel resizes forever because of layouting edge cases. I've seen it happen. It's bad. `}<inlineCode parentName="p">{`getDimensionObject`}</inlineCode>{` gets measurements, `}<inlineCode parentName="p">{`setDimensions`}</inlineCode>{` is the state setter from a `}<inlineCode parentName="p">{`useState`}</inlineCode>{` hook. You can see `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/useDimensions/blob/master/src/index.js"
      }}>{`full code here`}</a>{`. Window `}<inlineCode parentName="p">{`resize`}</inlineCode>{` and `}<inlineCode parentName="p">{`scroll`}</inlineCode>{` listeners will re-run our `}<inlineCode parentName="p">{`measure()`}</inlineCode>{` function when things change. Scrolling will change its position, resizing might change its dimensions. There's a problem here 👉 if the container resizes and the window doesn't, we'll have stale dimensions. When you use JavaScript or CSS to resize an element in response to user events, for example. No bueno.`}</p>
    <h2 {...{
      "id": "intersectionobserver-to-the-rescue"
    }}>{`IntersectionObserver to the rescue!`}</h2>
    <p>{`Last night I decided to fix that with the new `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API"
      }}>{`IntersectionObserver API`}</a>{` `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=uSmd6VMEMTo"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M395%2067c0%2057%200%2064-2%2064l-2%202-23%201c-26%200-25%200-25%207l1%205v4c-2%204%200%206%205%207h5l-5%201c-6%201-7%202-6%207l1%202h26l26%201h-52l-1%202c-1%207-2%207%2027%207l26%201h-52l-1%202c-1%207-2%207%2027%207h26l-26%201-26%201v11l-1%205c0%203%200%203-4%203-4-1-4%200-5%202%200%203-2%204-2%202l-1-1c-3%200-3-3-3-32v-27h-79a834%20834%200%2001-98-1c1%201-4%201-13%201l-14%201-1%206c0%205-1%205-3%206s-3%201-3%2010v9h-4c-4%201-8-2-8-6%200-2-1-2-3-2l-3-1-3-3-3-3c0-1-6-5-7-4l-4-1h-3l-3%201c-6-1-15%203-17%208l-2%2011c-1%2011-3%2013-9%2010-2-1-2-1%200-1%204%200%205-2%201-2h-2l3-1%203-1-3-1-3-1h2l3-1-2-1h-2l2-2h4l-4-1h-3l4-2%204-1h-7l3-1%201-2c-2%200-2%200-1-1s2-2%201-3l3-2%203-1h-6l2-1c4-2%204-2%202-3v-1l1-2v-3H17v14c-2%201-1%2012%201%2012%201-1%201%200%201%203s0%203-1%202h-4c-3%201-3%201-2%203%203%207-2%2015-9%2014l-3-1v19h400V5c0-3%200-3-2-3h-3v65M12%205l-1%202c0%202-1%202-5%202H1v15h216v-4c0-3%201-4%202-4l1-4c0-2-1-3-5-3-3%200-4%200-3-1%200-2-2-4-4-3l-1%203c-1%201-1%201-1-1V4h-97L12%205m10%206c-3%204%200%204%2075%204%2072%200%2073-1%2073-2%200-2-1-3-74-3l-74%201m168%2095v12c1%202%2011%202%2016%201l4-1v-12l-10-1-10%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a5479d7603c303d724a5d145e4280988/ca0a1/techletter.app-screenshot-1554309485818.webp 223w", "/static/a5479d7603c303d724a5d145e4280988/75680/techletter.app-screenshot-1554309485818.webp 445w", "/static/a5479d7603c303d724a5d145e4280988/d3be9/techletter.app-screenshot-1554309485818.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a5479d7603c303d724a5d145e4280988/e92b6/techletter.app-screenshot-1554309485818.png 223w", "/static/a5479d7603c303d724a5d145e4280988/e66bf/techletter.app-screenshot-1554309485818.png 445w", "/static/a5479d7603c303d724a5d145e4280988/e85cb/techletter.app-screenshot-1554309485818.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a5479d7603c303d724a5d145e4280988/e85cb/techletter.app-screenshot-1554309485818.png",
                "alt": "https://www.youtube.com/watch?v=uSmd6VMEMTo",
                "title": "https://www.youtube.com/watch?v=uSmd6VMEMTo",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://www.youtube.com/watch?v=uSmd6VMEMTo`}</figcaption>{`
  `}</figure></a>{` After some research I realized I was wrong. IntersectionObserver doesn't do what I thought it does, but it's super neat anyway. You want to use the `}<inlineCode parentName="p">{`IntersectionObserver`}</inlineCode>{` API when you have two DOM nodes and you want to know when their intersection changes. It's all in the name right? A common use-case is something like my `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/react-lazyload-fadein"
      }}>{`react-lazyload-fadein library`}</a>{` where you want to lazy load images juuuuust before they become visible. You could create a new intersection observer between the document and your placeholder node and wait for notifications. Super neat, not what's going to fix our resize edge case. `}<a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1113313756325355520"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "106.27802690582959%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'426\\'%20viewBox=\\'0%200%20400%20426\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M35%207c-13%203-16%2021-4%2028%204%203%2012%203%2016%200%203-2%204-4%202-4l-2-2c-1-4%201-4%201-1%201%202%201%202%202%201h1c1%202%203-3%203-8%200-9-9-16-19-14m45%203v1l-1%201h-8c-2-2-3%200-2%204%201%203%204%204%204%202h1c1%202%204%200%204-2s0-2%201%200c0%202%201%203%205%203l5-1h7c0-2%200-2%202%200l3%201c2-1%203-3%201-3l-2-1%202-1%201-1c0-2-3-2-5%200h-2c0-1-3-2-5-1h-7c-2%201-2%201-2-1l-1-2-1%201m41%201c0%201-1%202-2%201h-3l-1-1-4-1-4%201%201%201%201%203%202%204%202-4%201-3v3c0%203%201%204%207%204%203%200%203%200%203-5s-2-7-3-3m4%203c0%204%203%207%203%204%200-2%200-2%202-1%202%203%209%202%2010-1l1-2%201-1c-1-2-5-2-6-1h-2c-2-1-2-1-4%201l-2%202v-3c0-2%200-3-2-3l-1%205m166-1c-6%206-4%2014%203%2018%205%203%2047%203%2052%201%209-4%2011-13%205-19l-4-3h-53l-3%203m3%200c-6%203-7%2010-3%2015l3%203h52l3-3c4-3%204-9%201-14l-3-2-25-1c-21%200-26%200-28%202M81%2026l-2%201-2-1c-2%200-3%203-1%205h3c1%201%201%201%202-1s1-2%201%200%206%203%206%201h2l3%201-1-2v-1l3%202%202%201v-4c3-1%201-2-5-2l-8-1c-1-1-2%200-3%201m153%2024c-4%204-1%2011%204%2011%204%200%206-2%206-6%200-6-7-9-10-5m-80%204c-2%203%200%207%204%207%201%200%202%200%201%201l-2%201-2%201%202%201c4%200%206-2%206-9v-5h-3c-3%200-4%201-6%203m94%2018c-3%203-1%209%203%209%203%200%203%202%200%202l-3%201h7l1-7v-6h-3l-5%201M63%2094l-2%202v230l3%202%202%202h305l2-3c3-4%203-228%200-232l-2-3H218C66%2092%2065%2092%2063%2094m83%20272c-3%202-3%2011%200%2012%202%201%202%201%202-1s0-2%202%200c1%203%202%203%204%202v-7c2-5-4-9-8-6m16%202c-6%208%205%2017%2012%2010%204-6%201-13-6-13-3%200-4%201-6%203m19-1c-4%204%200%2013%206%2013%204%200%205-2%205-7l-1-7c-2-2-8-1-10%201m-52%200c-5%201-7%206-3%2011%204%206%2015%201%2014-6-1-5-4-7-11-5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/624904e42e7f18026a90f978907e5e7f/ca0a1/techletter.app-screenshot-1554309486281.webp 223w", "/static/624904e42e7f18026a90f978907e5e7f/75680/techletter.app-screenshot-1554309486281.webp 445w", "/static/624904e42e7f18026a90f978907e5e7f/d3be9/techletter.app-screenshot-1554309486281.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/624904e42e7f18026a90f978907e5e7f/e92b6/techletter.app-screenshot-1554309486281.png 223w", "/static/624904e42e7f18026a90f978907e5e7f/e66bf/techletter.app-screenshot-1554309486281.png 445w", "/static/624904e42e7f18026a90f978907e5e7f/e85cb/techletter.app-screenshot-1554309486281.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/624904e42e7f18026a90f978907e5e7f/e85cb/techletter.app-screenshot-1554309486281.png",
                "alt": "https://twitter.com/Swizec/status/1113313756325355520",
                "title": "https://twitter.com/Swizec/status/1113313756325355520",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/Swizec/status/1113313756325355520`}</figcaption>{`
  `}</figure></a></p>
    <h2 {...{
      "id": "resizeobserver-thats-the-thing-"
    }}>{`ResizeObserver, that's the thing 👌`}</h2>
    <p><a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver"
      }}>{`ResizeObserver`}</a>{` is an even newer API. Mozilla calls it "experimental". Support is lacking, but there are polyfills you can use. I used `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/resize-observer-polyfill"
      }}>{`this one`}</a>{` The idea here is that you can create a new observer object, give it a DOM node to observe and it's going to call your function when something changes. You can give it multiple nodes too. Something like this 👇 `}<a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20Observed()%20%7B%0A%20%20%20%20const%20ref%20%3D%20useRef()%3B%0A%20%20%20%20useEffect(()%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20const%20ro%20%3D%20new%20ResizeObserver(entries%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20const%20node%20%3D%20entries%5B0%5D.target%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%2F%2F%20do%20whatever%20with%20new%20size%0A%20%20%20%20%20%20%20%20%7D)%0A%20%20%20%20%20%20%20%20ro.observe(ref.current)%3B%0A%20%20%20%20%20%20%20%20return%20ro.disconnect%3B%0A%20%20%20%20%7D%2C%20%5B%5D)%0A%0A%20%20%20%20return%20%3Cdiv%20ref%3D%7Bref%7D%3E...%3C%2Fdiv%3E%0A%7D%0A"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "502px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "83.85650224215246%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'335\\'%20viewBox=\\'0%200%20400%20335\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2040c-2%202-3%20252-1%20256l2%202h344l2-2c2-4%201-254-1-256-2-3-344-3-346%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/ebfbbb17610ec5bc0083b3a75924fc89/ca0a1/techletter.app-screenshot-1554309485677.webp 223w", "/static/ebfbbb17610ec5bc0083b3a75924fc89/75680/techletter.app-screenshot-1554309485677.webp 445w", "/static/ebfbbb17610ec5bc0083b3a75924fc89/20682/techletter.app-screenshot-1554309485677.webp 502w"],
              "sizes": "(max-width: 502px) 100vw, 502px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/ebfbbb17610ec5bc0083b3a75924fc89/e92b6/techletter.app-screenshot-1554309485677.png 223w", "/static/ebfbbb17610ec5bc0083b3a75924fc89/e66bf/techletter.app-screenshot-1554309485677.png 445w", "/static/ebfbbb17610ec5bc0083b3a75924fc89/eea79/techletter.app-screenshot-1554309485677.png 502w"],
              "sizes": "(max-width: 502px) 100vw, 502px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/ebfbbb17610ec5bc0083b3a75924fc89/eea79/techletter.app-screenshot-1554309485677.png",
              "alt": "techletter app screenshot 1554309485677",
              "title": "techletter app screenshot 1554309485677",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`Create a new `}<inlineCode parentName="p">{`ResizeObserver`}</inlineCode>{` in an effect post initial mount. Give it a method that runs when the observer fires, make it observe your React element, return the `}<inlineCode parentName="p">{`disconnect`}</inlineCode>{` function to clean up on unmount. Perfect. Much cleaner than the hacky solution 👌 Except it doesn't work. You can see it `}<a parentName="p" {...{
        "href": "https://youtu.be/uSmd6VMEMTo?t=1756"
      }}>{`in the stream`}</a>{` around the 29 minute mark. ResizeObserver was going crazy and firing as fast as we could read. Remember when I said you can run into subtle layouting edge cases where things are unstable and resize very often? That. So we gave up, reverted back to `}<inlineCode parentName="p">{`window.addEventListener`}</inlineCode>{`, and left the edge case alone. Pretend like none of this ever happened. But it was fun to experiment :)`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      